<template>
	<div :class="{'ly-is-full':isFull}">
		<div class="table">
			<div class="tableToolBar">
				<div>
					<el-button type="primary" icon="Plus" @click="dialogFlag=true;title='新增栏目'">新增</el-button>
					<el-button type="danger" icon="Delete" @click="removeHandler"
						:disabled="selectList.length == 0">删除</el-button>
				</div>
			</div>
			<el-table v-bind="tableOptions" :data="tableData" :height="tableHeight" ref="tableref" row-key="id"
				style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50" align="center" />
				<el-table-column prop="sort" label="序号" width="90" align="center" />
				<el-table-column prop="name" label="栏目名称" width="180" align="center" />
				<el-table-column prop="cover" label="栏目封面" width="180" align="center">
					<template #default="{row,$index}">
						<el-image :src="row.cover" v-if="row.cover" fit="cover" style="height: 50px;"></el-image>
						<el-text v-else type="primary">暂无封面</el-text>
					</template>
				</el-table-column>
				<el-table-column prop="desc" label="栏目描述" width="180" align="center" />
				<el-table-column prop="create_datetime" label="创建时间" width="180" align="center" />
				<el-table-column prop="update_datetime" label="更新时间" width="180" align="center" />
				<el-table-column type="state" label="栏目状态" align="center">
					<template #default="{row,$index}">
						<el-tag v-if="row.is_enable" type="success">启用</el-tag>
						<el-tag v-else type="danger">禁用</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="260">
					<template #header>
						<div style="display: flex;justify-content: space-between;align-items: center;">
							<div>操作</div>
							<div @click="setFull">
								<el-tooltip content="全屏" placement="bottom">
									<el-icon><full-screen /></el-icon>
								</el-tooltip>
							</div>
						</div>
					</template>
					<template #default="scope">
						<div style="display: flex;">
							<el-button icon="Edit" type="primary" plain text size="small"
								@click="editHandler(scope.row)">编辑</el-button>
							<el-button icon="Delete" type="danger" plain text size="small"
								@click="removeRow(scope.row)">删除</el-button>
							<el-button type="success" plain text size="small"
								@click="$router.push('/article-list?column='+scope.row.id)">
								<svg-icon icon-class='lyicon-date-range-field'></svg-icon>
								<span style="margin-left: 6px;">栏目内容</span>
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<ly-dialog v-model="dialogFlag" :title="title" width="40%" :before-close="handleDialogClose">
			<div>
				<el-form ref="columnForm" :model="columnData" :rules="rules" label-width="100px">
					<el-form-item label="上级栏目" prop="parent">
						<el-cascader style="width: 100%" :show-all-levels="false" :options="treeData" v-model="columnData.parent"
							:props="{ checkStrictly: true ,label:'name',value:'id'}" clearable></el-cascader>
					</el-form-item>
					<el-form-item label="栏目名称" prop="name">
						<el-input v-model="columnData.name" placeholder="请输入栏目名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="栏目描述" prop="desc">
						<el-input v-model="columnData.desc" placeholder="请输入栏目描述" :rows="2" type="textarea" maxlength="120"
							resize="none"></el-input>
					</el-form-item>
					<el-form-item prop="sort">
						<template #label>
							<div style="display: flex;align-items: center;">
								<span style="margin-right: 6px;">排序</span>
								<el-tooltip content="数值越小权重越大" placement="right">
									<el-icon>
										<QuestionFilled />
									</el-icon>
								</el-tooltip>
							</div>
						</template>
						<el-input-number v-model="columnData.sort" :min="title=='新增栏目'?maxSort+1:1"
							placeholder="请输入排序号"></el-input-number>
					</el-form-item>
					<el-form-item label="是否启用" prop="is_enable">
						<el-radio-group v-model="columnData.is_enable">
							<el-radio :value="true">启用</el-radio>
							<el-radio :value="false">禁用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="封面" prop="cover">
						<el-upload style='width:100%;' drag :limit="1" :data="{dirs:'column'}" :action="url+'article/upload/'"
							:show-file-list="false" :headers="{Authorization:'JWT '+token}" :before-upload="beforeUploadHandler"
							:on-success="fileSuccess">
							<template v-if="!columnData.cover">
								<el-icon class="el-icon--upload"><upload-filled /></el-icon>
								<div class="el-upload__text">拖拽文件到这 或 <em>点击上传</em></div>
							</template>
							<template v-else>
								<el-image style="width:100px" :src="columnData.cover"></el-image>
							</template>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<template v-slot:footer>
				<div style="display: flex;justify-content: flex-end;">
					<el-button @click="handleDialogClose">取消</el-button>
					<el-button type="primary" @click="submitData">确定</el-button>
				</div>
			</template>
		</ly-dialog>
	</div>
</template>

<script setup>
	import {
		url,
		mediaUrl
	} from '@/api/url'
	import {
		getToken,
		buildTree
	} from '@/utils/util'
	import {
		columnGet,
		columnPost,
		columnPut,
		columnDelete
	} from "@/api/court"
	import LyDialog from "@/components/dialog/dialog"
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		getTableHeight
	} from "@/utils/util"
	import {
		ref,
		reactive,
		watch,
		onMounted,
		onUnmounted,
		nextTick
	} from "vue" 
	const token = getToken()
	const tableData = ref([])
	const tableHeight = ref(500)
	const isFull = ref(false)
	const treeData = ref([])

	const columnForm = ref(null)
	const dialogFlag = ref(false)
	const title = ref("")
	const selectList = ref([])
	const maxSort = ref(0)

	const formInline = reactive({
		page: 1,
		limit: 10,
		title: "",
		state: "",
		time: ""
	})

	let columnData = reactive({
		name: "",
		desc: "",
		sort: 0,
		cover: "",
		is_enable: true,
		parent: ''
	})

	const rules = reactive({
		name: [{
				required: true,
				message: '请输入栏目名称',
				trigger: 'blur'
			},
			{
				max: 60,
				message: '栏目名称最多只能输入60个字符',
				trigger: 'blur'
			},
		],
		// desc: [{
		// 	required: true,
		// 	message: '请输入栏目名称',
		// 	trigger: 'blur'
		// }],
		sort: [{
			required: true,
			message: '请输入排序号',
			trigger: 'blur'
		}, ],
		is_enable: [{
			required: true,
			message: '请选择启用状态',
			trigger: 'blur'
		}, ]
	})

	const tableOptions = ref({
		stripe: false, // 斑马纹
		highlightCurrentRow: false, // 是否要高亮当前行
		border: true, // 是否有纵向边框
		fit: true, // 列的宽度是否自撑开
		size: 'default', // Table 的尺寸
		lazy: false, // 是否需要懒加载
		showHeader: true, //是否显示表头
		defaultExpandAll: false, //是否默认展开所有行
	})

	//初始化页面
	function initPage() {
		columnGet({
			page: 1,
			limit: 10000
		}).then(res => {
			if (res.code == 2000) {
				const tree = buildTree(res.data.data)
				tableData.value = tree
				tableData.value.map(node => {
					if (node.sort > maxSort.value) maxSort.value = node.sort
				})
				columnData.sort = maxSort.value + 1
			}
		})
		columnGet({
			page: 1,
			limit: 10000,
			is_enable:true
		}).then(res => {
			if(res.code == 2000){
				treeData.value = buildTree(res.data.data)
			}
		})
	}

	//多选框选中的数据 将选中的数据放入selectList数组中
	function handleSelectionChange(selection) {
		selectList.value = selection
	}

	//dialog取消事件 清空输入框中的值
	function handleDialogClose() {
		dialogFlag.value = false
		columnForm.value.resetFields()
		columnData = reactive({
			name: "",
			desc: "",
			sort: maxSort.value + 1,
			cover: "",
			is_enable: true,
			parent: ''
		})
	}

	//上传文件校验钩子
	function beforeUploadHandler(file) {
		if (file.size / 1024 / 1024 > 100) {
			ElMessage.warning("上传文件的大小最大为20MB")
			return false
		}
		const reg = /(png|jpeg|jpg)$/
		if (!reg.test(file.name)) {
			ElMessage.warning("请上传图片格式的文件")
			return false
		}
		return true
	}

	function fileSuccess(resp) {
		if (resp.code == 2000) {
			columnData.cover = "http://" + mediaUrl + '/media' + resp.data.data[0]
		}
	}

	//dialog点击确定事件，将表单内容发往后端
	function submitData() {
		columnForm.value.validate(flag => {
			if (flag) { //验证表单成功
				const params = JSON.parse(JSON.stringify(columnData))
				params.parent = Array.isArray(params.parent) ? params.parent[params.parent.length - 1] : params.parent
				if (!params.parent) delete params.parent
				if (params.id) {
					delete params.create_datetime
					delete params.update_datetime
					columnPut(params).then(res => { //更新
						if (res.code == 2000) {
							ElMessage.success("更新栏目成功~")
							initPage()
							handleDialogClose()
						} else ElMessage.warning(res.msg)
					})
				} else {
					columnPost(params).then(res => { //新增
						if (res.code == 2000) {
							ElMessage.success("新增栏目成功~")
							initPage()
							handleDialogClose()
						} else ElMessage.warning(res.msg)
					})
				}
			}
		})
	}

	//表格中的删除事件 所有的删除事件需要进行一次确认 直接将这一行数据放到selectList数组中
	function removeRow(data) {
		ElMessageBox.confirm('是否确认删除当前行的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			selectList.value.push(data)
			remove([data])
		})
	}

	//根据选中的数据进行删除 删除完毕后需要清空selectList数组
	function removeHandler() {
		if (!selectList.value.length) return
		ElMessageBox.confirm('是否确认删除选择的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove(selectList.value)
		})
	}

	//通用发起删除请求
	function remove(arr) {
		let flags = []
		if (arr.some(node => node.children.length != 0)) return ElMessage.warning("删除的栏目有子栏目，无法删除")
		arr.map(item => {
			columnDelete(item.id).then(res => {
				if (res.code == 2000) {
					flags.push(true)
					if (flags.length == arr.length) {
						ElMessage.success("栏目删除成功")
						initPage()
					}
				}
			})
		})
	}

	//表格中编辑事件 data为那一行的数据
	function editHandler(data) {
		dialogFlag.value = true
		title.value = "修改栏目信息"
		let param = JSON.parse(JSON.stringify(data))
		delete param.creator

		Object.assign(columnData, param)
	}

	function setFull() {
		isFull.value = !isFull.value
		window.dispatchEvent(new Event('resize'))
	}

	function getTheTableHeight() {
		let tabSelectHeight = 0
		tableHeight.value = getTableHeight(tabSelectHeight, false) - 175
	}

	function listenResize() {
		nextTick(() => {
			getTheTableHeight()
		})
	}

	onMounted(() => {
		initPage()
		getTheTableHeight()
		window.addEventListener('resize', listenResize);
	})

	onUnmounted(() => {
		window.removeEventListener("resize", listenResize);
	})
</script>

<style scoped lang="scss">
	.tableToolBar {
		display: flex;
		justify-content: flex-end;
		font-size: 14px;
		background: var(--el-bg-color);
		padding: 8px;
		border-top: 1px solid var(--el-border-color-lighter);
		border-left: 1px solid var(--el-border-color-lighter);
		border-right: 1px solid var(--el-border-color-lighter);
	}
</style>